<template>
  <article class="payment-type" :class="{ disabled }">
    <v-tooltip
      v-for="(option, index) in options"
      :key="option.type"
      right
      :disabled="option.enabled"
      :color="'rgba(0,0,0,0.8)'"
      :z-index="tooltipZIndex"
    >
      <template v-slot:activator="{ on, attrs }">
        <div
          :class="{ active: paymentType === option.type, unavailable: !option.enabled, 'mb-5': index < options.length - 1 }"
          class="payment-type-section"
          v-bind="attrs"
          v-on="on"
          @click="select(option)"
        >
          <div class="icon">
            <component :is="option.icon" />
          </div>
          <div class="name">
            <span class="label">{{ option.label }}</span>
          </div>
          <transition name="fadeLeft">
            <div v-if="paymentType === option.type" class="icon-check">
              <font-awesome-icon icon="check" color="#ffffff" />
            </div>
          </transition>
        </div>
      </template>
      {{ option.hint }}
    </v-tooltip>
  </article>
</template>

<script>
  import IconCashier from '@/components/icons/IconCashier'
  import IconTerminal from '@/components/icons/IconTerminal'
  import PaymentType from '@/models/enums/PaymentType'

  export default {
    name: 'PaymentTypeSelect',
    components: {
      IconCashier,
      IconTerminal,
    },
    model: {
      prop: 'value',
      event: 'change',
    },
    props: {
      value: {
        type: String,
        default: 'cash',
      },
      types: {
        type: Array,
        default: () => [],
      },
      // что принимает филиал; null = набор не настроен, доступно всё из types
      enabledTypes: {
        type: Array,
        default: null,
      },
      disabled: Boolean,
    },
    data () {
      return {
        // подсказка должна всплывать над диалогом
        tooltipZIndex: 9999,
        variants: [
          { type: PaymentType.Cash, label: 'Наличные', icon: IconCashier, hint: 'Филиал не принимает оплату наличными' },
          { type: PaymentType.Terminal, label: 'Карта', icon: IconTerminal, hint: 'Филиал не принимает оплату картой' },
        ],
      }
    },
    computed: {
      paymentType: {
        get () {
          return this.value
        },
        set (value) {
          if (this.disabled) return
          this.$emit('change', value)
        },
      },
      options () {
        return this.variants
          .filter(variant => this.types.some(item => item.type === variant.type))
          .map(variant => ({ ...variant, enabled: !this.enabledTypes || this.enabledTypes.includes(variant.type) }))
      },
    },
    methods: {
      select (option) {
        if (option.enabled) this.paymentType = option.type
      },
    },
  }
</script>

<style lang="less" scoped>
  .payment-type {
    &.disabled .payment-type-section {
      cursor: default;
    }

    .payment-type-section {
      position: relative;
      border-radius: 5px;
      cursor: pointer;
      transition: box-shadow 0.2s ease;
      background-color: #D8DBE6;
      height: 130px;
      z-index: 0;

      span {
        display: block;
      }

      &.unavailable {
        cursor: not-allowed;
        opacity: 0.45;
      }
    }

    .name {
        font-size: 22px;
        padding-left: 78px;
        padding-top: 48px;
    }

    .icon {
      position: absolute;
      top: 0;
      left: 10px;
      bottom: 0;
      margin: auto;
      z-index: -1;
      height: 100px;

      svg {
        max-height: 100px;
      }
    }

    .icon-check {
      position: absolute;
      right: 13px;
      top: 11px;
      width: 35px;
      height: 35px;
      background-color: #368D3A;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
</style>
